export const LessonPlan_Privacy = [
  {
    value: 1,
    name: 'Share Globally',
  },
  {
    value: 2,
    name: 'Share within School',
  },
  {
    value: 3,
    name: 'Keep Private',
  },
];

export const Teacher_LessonPlan_Privacy = [
  {
    value: 1,
    name: 'Shared Globally',
  },
  {
    value: 2,
    name: 'Shared within School',
  },
  {
    value: 3,
    name: 'Private',
  },
];

export const CHANGE_TRIAL_ROLES = [
  {
    value: 1,
    name: 'Principal',
  },
  {
    value: 2,
    name: 'Teacher',
  },
  {
    value: 3,
    name: 'Student',
  },
];

export const TRIAL_TEACHER_TEACHING_INFO = {
  bellShedule: 'true',
  designation: 'Highschool',
  examPerdays: 10,
  teachingGrades: [10],
  teachingSubject: [5, 15, 11, 10, 22, 23],
  teachingSubjectcount: 6,
};

export const TAB_TITLES = {
  WeeklyPeriods: 'Weekly Periods',
  LessonPlans: 'Lesson Plans',
  Classrooms: 'Classrooms',
  Students: 'Students',
  StandardsPerformance: 'Standards Performance',
  AcademicInformation: 'Academic Information',
};

export const LESSON_PLAN_VERSION_LIMIT = 10;
